'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _rebass = require('rebass');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Hero = function Hero(_ref) {
  var bg = _ref.bg,
      backgroundImage = _ref.backgroundImage,
      bgOpacity = _ref.bgOpacity,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ['bg', 'backgroundImage', 'bgOpacity', 'style', 'children']);

  return _react2.default.createElement(
    _rebass.Relative,
    null,
    backgroundImage && _react2.default.createElement(
      _rebass.Absolute,
      {
        top: 0, right: 0, bottom: 0, left: 0, zIndex: -2,
        style: { height: '100%' } },
      _react2.default.createElement(_rebass.Image, { src: backgroundImage, alt: '', width: 1, style: { height: '100%', objectFit: 'cover' } })
    ),
    _react2.default.createElement(_rebass.Absolute, {
      top: 0, right: 0, bottom: 0, left: 0, zIndex: -1,
      bg: bg, style: { opacity: backgroundImage ? bgOpacity : 1, height: '100%' } }),
    _react2.default.createElement(
      _rebass.Flex,
      _extends({ style: _extends({
          minHeight: '100vh'
        }, style) }, props),
      children
    )
  );
};

Hero.displayName = 'Hero';
Hero.defaultProps = {
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  bgOpacity: 0.9
};
Hero.propTypes = {
  bg: _propTypes2.default.string,
  backgroundImage: _propTypes2.default.string,
  bgOpacity: _propTypes2.default.number,
  style: _propTypes2.default.object,
  children: _propTypes2.default.any
};
exports.default = Hero;